import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { KatSpinner } from '@amzn/katal-react';

import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import ErrorBoundary from './components/shared/errorBoundary/ErrorBoundary';
import store from './store/store';
import { registerGlobalErrorHandlers } from './logging/globalErrorHandlers';
import { navigatorUiLogger } from './logging/runtime';

import '@amzn/katal-components/styles.css';
import './index.scss';
import { Init } from "src/config/Auth";

// The Suspense component causes React to display the fallback KatSpinner until
// the i18n translation strings have been loaded.

Init();

registerGlobalErrorHandlers(navigatorUiLogger);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <ErrorBoundary
            onError={(error, errorInfo) => {
                navigatorUiLogger.error(
                    'react_error_boundary',
                    error,
                    { componentStack: errorInfo.componentStack },
                );
            }}
        >
            <Provider store={store}>
                <AppInitWrapper>
                    <React.Suspense fallback={<KatSpinner size="large" />}>
                        <App />
                    </React.Suspense>
                </AppInitWrapper>
            </Provider>
        </ErrorBoundary>
    </React.StrictMode>
);
